import { render, staticRenderFns } from "./ejes.vue?vue&type=template&id=3c37c6c8&"
import script from "./ejes.vue?vue&type=script&lang=ts&"
export * from "./ejes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports